import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdEmail } from 'react-icons/md';
import { db } from '../../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Please enter a valid email address'); return; }
    try {
      await addDoc(collection(db, 'newsletter'), { email, timestamp: serverTimestamp() });
      toast.success('Thank you for subscribing!');
      setEmail('');
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <footer className="footer">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Newsletter */}
      <div className="footer-newsletter">
        <div className="newsletter-inner">
          <div className="newsletter-text">
            <p className="newsletter-label">Stay in the Loop</p>
            <h3 className="newsletter-heading">Subscribe to Our Newsletter</h3>
            <p className="newsletter-sub">Exclusive updates, curated experiences, and luxury insights — delivered to your inbox.</p>
          </div>
          <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Contact Row */}
      <div className="footer-contact-row">
        {/* Left — Email + Legal */}
        <div className="footer-left-col">
          <div className="footer-legal-inline">
            <div className="footer-contact-item">
              <MdEmail size={20} className="footer-icon" />
              <span className="footer-email-text">ck@luxeunbounded.com</span>
            </div>
            <div className="footer-policy-group">
              <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms-conditions" className="footer-link">Terms &amp; Conditions</Link>
              <p className="footer-copyright">© {new Date().getFullYear()} Luxe Unbounded. All rights reserved.</p>
            </div>
          </div>
        </div>

        {/* Right — Our Presence */}
        <div className="footer-presence">
          <span className="footer-presence-title">Our Presence</span>
          <span className="footer-presence-name">Luxe Unbounded House</span>
          <span className="footer-presence-location">Indiranagar, Bengaluru</span>
          <span className="footer-presence-note">Private office. Visits by prior appointment only.</span>
          <a href="mailto:ck@luxeunbounded.com?subject=Request Access — Luxe Unbounded" className="footer-presence-btn">Request Access</a>
        </div>
      </div>

      {/* Bottom Bar — mobile only */}
      <div className="footer-bottom footer-bottom--mobile">
        <p className="footer-copyright">© {new Date().getFullYear()} Luxe Unbounded. All rights reserved.</p>
        <div className="footer-legal">
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms-conditions" className="footer-link">Terms &amp; Conditions</Link>
        </div>
      </div>

      {/* Bottom Bar — desktop hidden, shown in CSS only on mobile via footer-bottom--mobile */}
    </footer>
  );
};

export default Footer;
